module.exports = __webpack_public_path__ + "img/AddressInfo.ae4916ed.svg";